import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class AdminShelfApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.MANAGEMENT_SHELF);
  }

  /** 컬렉션 URL (끝 슬래시 1개 보장) */
  getCollectionUrl() {
    const base = String(this.getResourceUrl()).replace(/\/+$/, '');
    return `${base}/`;
  }

  /** FormData로 생성 (POST /shelves/) */
  createForm(formData) {
    const url = this.getCollectionUrl();
    return this.httpClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  /** JSON 바디로 생성이 필요할 때 */
  create(data) {
    const url = this.getCollectionUrl();
    return this.httpClient.post(url, data);
  }
}

export default new AdminShelfApi();
